<div class="auth-shell">
  <mat-card class="card-register auth-card">
    <h3 class="title">{{title | traduccion}}</h3>
    <form class="register-form auth-form" [formGroup]="form" (ngSubmit)="submitForm()">
      <div *ngIf="mode == 'reset'">
        <mat-form-field appearance="outline" class="auth-form-field">
          <mat-label>{{'tenantId' | traduccion}}</mat-label>
          <mat-icon matPrefix>apartment</mat-icon>
          <input
            matInput
            formControlName="tenantId"
            name="tenantId"
            type="number"
            min="1"
            autocomplete="off">
        </mat-form-field>
        <div *ngIf="tenantId.invalid && (tenantId.dirty || tenantId.touched)" class="text-danger">
          <small *ngIf="tenantId.errors.required">{{'tenantId.errors.required' | traduccion}}<br></small>
          <small *ngIf="tenantId.errors.min">{{'tenantId.errors.min' | traduccion}}<br></small>
        </div>

        <mat-form-field appearance="outline" class="auth-form-field">
          <mat-label>{{'email' | traduccion}}</mat-label>
          <mat-icon matPrefix>email</mat-icon>
          <input
            matInput
            formControlName="email"
            id="name"
            name="email"
            type="email"
            autocomplete="email">
        </mat-form-field>
        <div *ngIf="email.invalid && (email.dirty || email.touched)" class="text-danger">
          <small *ngIf="email.errors.required">{{'email.errors.required' | traduccion}}<br></small>
          <small *ngIf="email.errors.email">{{'email.errors.email' | traduccion}}<br></small>
        </div>
      </div>

      <div *ngIf="mode == 'change'">
        <mat-form-field appearance="outline" class="auth-form-field">
          <mat-label>{{'password' | traduccion}}</mat-label>
          <mat-icon matPrefix>vpn_key</mat-icon>
          <input
            matInput
            formControlName="newPassword"
            name="newPassword"
            type="password"
            autocomplete="new-password">
        </mat-form-field>

        <div *ngIf="passwordStrength > 0" class="strength-bar">
          <div
            class="strength"
            [ngClass]="{
              'weak': passwordStrength <= 2,
              'medium': passwordStrength === 3 || passwordStrength === 4,
              'strong': passwordStrength === 5
            }"
            [style.width.%]="passwordStrength * 20">
          </div>
        </div>

        <p *ngIf="passwordStrength > 0" class="auth-strength-label">
          Fortaleza:
          <span class="auth-strength-badge" [ngClass]="{
            'badge-danger': passwordStrength <= 2,
            'badge-warning': passwordStrength === 3 || passwordStrength === 4,
            'badge-success': passwordStrength === 5
          }">
            {{ passwordStrength <= 2 ? 'Debil' : passwordStrength < 5 ? 'Media' : 'Fuerte' }}
          </span>
        </p>

        <div *ngIf="newPassword?.touched && newPassword?.invalid" class="text-danger">
          <small *ngIf="newPassword.errors.required">{{'password.errors.required' | traduccion}}<br></small>
          <small *ngIf="newPassword?.errors?.['minLength']">{{'password.errors.minlength' | traduccion}}<br></small>
          <small *ngIf="newPassword?.errors?.['missingLowercase']">{{'password.errors.missingLowercase' | traduccion}}<br></small>
          <small *ngIf="newPassword?.errors?.['missingUppercase']">{{'password.errors.missingUppercase' | traduccion}}<br></small>
          <small *ngIf="newPassword?.errors?.['missingDigit']">{{'password.errors.missingDigit' | traduccion}}<br></small>
          <small *ngIf="newPassword?.errors?.['missingSpecial']">{{'password.errors.missingSpecial' | traduccion}}<br></small>
        </div>

        <mat-form-field appearance="outline" class="auth-form-field">
          <mat-label>{{'passwordConfirm' | traduccion}}</mat-label>
          <mat-icon matPrefix>vpn_key</mat-icon>
          <input
            matInput
            formControlName="passwordConfirm"
            name="passwordConfirm"
            type="password"
            autocomplete="new-password">
        </mat-form-field>
        <div *ngIf="form.hasError('passwordMismatch') && form.get('passwordConfirm')?.touched" class="text-danger">
          <small>{{'password.errors.passwordNotMatch' | traduccion}}</small>
        </div>
      </div>

      <button mat-stroked-button color="primary" type="submit" [disabled]="!form.valid || sent" class="btn-round auth-submit">
        {{'reset_password' | traduccion}}
      </button>
    </form>

    <div class="forgot">
      <button mat-button type="button" (click)="_goTo('signin')" class="auth-link btn-terciary">
        {{'signin' | traduccion}}
      </button>
    </div>
  </mat-card>
</div>
